import Glide from "@glidejs/glide";

const navTrigger = document.querySelector(".nav-burger");
const mobileNav = document.querySelector(".mobile-nav");
const mobileLinks = document.querySelectorAll(".mobile-nav__link");

if (navTrigger && mobileNav) {
  navTrigger.addEventListener("click", () => {
    navTrigger.classList.toggle("active");
    mobileNav.classList.toggle("active");
    document.body.classList.toggle("overflowed");
  });
}

if (mobileLinks) {
  mobileLinks.forEach((el) => {
    el.addEventListener("click", () => {
      document.body.classList.toggle("overflowed");
      navTrigger.classList.toggle("active");
      mobileNav.classList.toggle("active");
    });
  });
}

new Glide(".glide").mount();

const copyrightYearEls = document.querySelectorAll('[data-copyright-year]')
const currentYear = new Date().getFullYear()

copyrightYearEls.forEach((el) => {
  el.textContent = String(currentYear)
})
